module.exports = __webpack_public_path__ + "static/papa-ea33719a2f8558d80623bc8ae5f4c7ce.jpg";